import React, { useState, useEffect } from "react";
import { tipsandtricks } from "../../redux/actions";
import { Link } from "react-router-dom";

const TipandTrick = () => {
  const [dashboard, setdashboard] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const data = await tipsandtricks();
        setdashboard(data || []); // Ensure orders exist
      } catch (err) {
        setError(err.message);
      }
    };
    fetchOrders();
  }, []);

  console.log("......", dashboard);
  return (
    <section className="hot-deals pt-20">
      {/* component 1 about us*/}
      <div className="container container-lg">
        <div className="section-heading">
          <div className="flex-between flex-wrap gap-8">
            <h2 className="mb-0 text-blue">Tips & Tricks</h2>
          </div>
        </div>
      </div>
      <div className="container container-lg">
        <div className="section-heading">
          <div style={{ display: "flex", gap: "5px" }}>
            <button className="btn bg-main-600">Hygiene</button>
            <button className="btn bg-main-600">Food</button>
          </div>
        </div>
      </div>
      <div className="container container-lg ">
        <div className="row gy-4">
          {/* grid for orders */}
          <div className="col-sm-12 ">
            <div className="border border-gray-100 hover-border-main-600 bg-light-grey rounded-16 position-relative transition-2 offer-card position-relative overflow-hidden p-16">
              <div className="py-xl-2">
                <h4 className="text-blue ack mb-8">Active Orders</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="short-product">
        <div className="container container-lg">
          <div className="row gy-4">
            <div className="col-xxl-3 col-lg-4 col-sm-6">
              <div className="product-card d-flex flex-column h-100 p-8  position-relative transition-2">
                <Link
                  to="/product-details"
                  className="product-card__thumb flex-center"
                >
                  <img src="/assets/images/logo/Image-coming-soon.png" alt="" />
                </Link>

                <h6 className="title text-lg fw-semibold mt-12 mb-8">
                  Understanding the Different Grades of Tissue Paper: A Buyer's
                  Guide
                </h6>
                <br></br>
                <p>new</p>
                <br></br>
                <p>
                  businesses should focus on tissue softness, strength,
                  absorption, and packaging sustainability when purchasing bulk
                  facial tissue. You can select high-quality products
                </p>
                <br></br>
                <h6>Read more</h6>
                {/* Push this content to the bottom */}
                <div className="product-card__content p-sm-2 mt-auto"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TipandTrick;
